module.exports = __webpack_public_path__ + "static/ctaBackground-a1ffce5b4c45253a82762d1c9eacfa61.svg";